module.exports = __webpack_public_path__ + "img/new-next-btn-g.6a9a9cfb.svg";